import * as React from 'react';
/**
 *
 * Original name: Android
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=4068%3A1931
 *
 */
export const AndroidExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m15.903 10.203 1.328-2.299a.27.27 0 0 0-.098-.367.266.266 0 0 0-.366.097l-1.344 2.329A8.2 8.2 0 0 0 12 9.233a8.201 8.201 0 0 0-3.423.73L7.233 7.634a.268.268 0 0 0-.368-.097.268.268 0 0 0-.097.367l1.327 2.3C5.806 11.443 4.256 13.76 4 16.471h16c-.256-2.712-1.806-5.029-4.097-6.269Zm-7.576 4.022a.67.67 0 1 1 0-1.342.67.67 0 0 1 0 1.342Zm7.345 0a.67.67 0 1 1 0-1.342.67.67 0 0 1 0 1.342Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
